import localeAntd from 'ant-design-vue/lib/locale-provider/es_ES';

const messages = {
  topBar: {
    profileMenu: {
      hello: 'Hola',
      editProfile: 'Editar Perfil',
      settings: 'Settings',
      logout: 'Salir',
    },
  },
  menuLeft: {
    top: {
      churchDashboard: 'Tablero de la Iglesia',
    },
    user: {
      churchPartner: 'Iglesia Miembro',
      evangelismPartner: '',
    },
    menu: {
      account: 'Cuenta',
      dashboard: 'Tablero',
      profile: 'Perfil',
      viewProfile: 'Ver Perfil',
      editProfile: 'Editar Perfil',
      orderCards: 'Ordenar Invitación Tarjetas',
      messages: 'Mensajes',
      trackProgress: 'Rastrear su progreso',
      studyGuides: 'Guías de Estudio',
      bulletinInsert: 'Inserciones de Boletines',
      resources: 'Recursos',
      monthlyVideos: 'Videos mensuales',
      videoPlayer: 'Reproductor de video',
      campuses: 'Dirección del buscador de iglesias',
      AccountInvoicePayment: 'Account Invoices, Payments, Manage Subscription',
      updateBillingInfo: 'Actualizar Información de Facturación',
      supportCenter: 'Centro de Apoyo',
      churchProfile: 'Perfil de la Iglesia',
      churchAccess: 'Acceso de la Iglesia',
    },
  },
  page: {
    dashboard: {
      getMostFromTruelife: {
        para1: '¡Para ganar el mayor impulso, use esta combinación específica!',
        para2: 'La primera semana, analice los primeros cuatro ingredientes que se enumeran a continuación.',
        para3: 'La segunda semana, comience a incorporar esta oración al final de cada servicio.',
        para4: 'Verbosidad del Covid para el final del Servicio para hacer que oren por sus tarjetas',
        para5:
          'Hermanos y hermanas, hoy han escuchado el mensaje y el Evangelio. Hay tres tarjetas de invitación frente a ustedes que representan a tres personas que no han tenido esa oportunidad. Por favor tomen esas tarjetas. Quiero que oremos para que Dios nos dé las tres personas adecuadas para entregarles las tarjetas también esta semana. Quizá se pregunten quiénes son, así que déjenme decirles. Creo que Dios quiere que le entreguen una tarjeta de invitación a cualquiera que les dé algo esta semana. En los autoservicios, en el banco, al mesero. Ahora, por favor, acompáñenme en un momento de oración en silencio, pidiendo a Dios que nos bendiga con estas tres personas para entregar las tarjetas esta semana.',
        para6: 'Final normal para que su gente ore por las cartas',
        para7:
          'Hermanos y hermanas, acaban de escuchar el sermón de hoy y el Evangelio. Frente a ustedes hay 5 tarjetas de invitación con ligas de goma que representan a 5 personas que no han podido tener esa enorme bendición. Por favor, tómenlas (las tienen en su mano), y tomemos un momento y oremos en silencio en su corazón para que Dios les dé las personas adecuadas para entregárselas esta semana. (Oren en silencio durante 15 segundos) luego cierren en oración colectiva',
      },
      churchTraningVideo: {
        para1: 'Haga clic para descargar el video de introducción (versión Covid)',
      },
      videoShareWithChuch: {
        para1: 'Haga clic para descargar el video de introducción',
      },
      getWeeklyResults: {
        para1: 'Aprenda a obtener resultados cada semana en este video de 2 minutos',
      },
      accountPaymentDate: {
        para1: 'Subscription Next Automatic Payment Date',
      },
      recentUpdate: {
        para1: 'Hemos actualizado nuestros términos de servicio y política de privacidad recientemente. Para verlo, haga clic en',
        link: 'aquí',
      },
    },
    orderCards: {
      instructionsResources: {
        para1: 'Fill out the form on this page to order your invitation cards from TrueLife.org. We recommend using a desktop computer to place the order, although the form is mobile friendly.',
      },
      reOrderingInstructions: {
        para1: 'If you need to place a re-order for cards please use our re-ordering form.',
        link: 'Click Here',
      },
    },
    trackProgress: {
      submitTrackYourProgress: {
        para1: 'Complete el formulario en esta página para seguir su progreso de nuestro equipo de servicio al cliente.',
      },
    },
    bulletinInserts: {
      bulletinInserts: {
        para1: 'Descargue encartes prediseñados para su boletín.',
        link: 'Kit de inserción de boletines',
        para2: 'Incluido en el kit',
      },
    },
    videoPlayer: {
      videoPlayerForYourChurchWebsite: {
        para1: 'Paso uno: Ingrese la URL del sitio web de su iglesia (ejemplo: www.miiglesia.com)',
        para2: 'Paso dos: elija categorías para incluir en el reproductor (o simplemente haga clic en Generar código para insertar para incluir todas las categorías)',
        para3: 'Agregar un botón de donación: ingrese la URL de su página de donación',
      },
    },
    campuses: {
      para1: 'Por favor, agregue las ubicaciones del campus de su iglesia',
      para2: 'Si solo tiene una ubicación, deje el nombre como está. Si tiene varias ubicaciones, agregue el nombre de la ubicación después del nombre de su iglesia ',
      para3: 'Ejemplo: Nombre de la iglesia - Nombre del campus',
      yourLocations: {
        para1: 'Por favor agregue un campus de la iglesia',
      },
    },
    dashboardCare: {
      howToSetupYourChurchProfile: {
        para1:
          'En el lado izquierdo, verá tanto el perfil de la iglesia como los elementos del menú de acceso a la iglesia. Es importante configurar la información de inicio de sesión de miembro de la iglesia, ya que es diferente del panel de control de su iglesia. Deberá crear un nombre de usuario para los miembros de su iglesia. Querrá utilizar el correo electrónico de contacto de su iglesia u otra dirección de correo electrónico dedicada para este propósito. También creará una contraseña y volverá a elegir algo fácil para ello, como 123TLC o Consejería. ',
      },
      howToDirectChurchMembersToTruelifeCare: {
        para1:
          'To direct your church members to TrueLifeCare.org, please use the bulletin inserts or projector images provided in your Church’s Dashboard. Make sure you include your church members login information that you created. On your launch service, use the video provided for your church members to watch. Continue to direct your church members to use this resource by highlighting this option on your church’s website, Facebook page, announcements, Bible Studies, and in your sermons.',
      },
      whyYouShouldIncludeAPersonalVideoFromThePastor: {
        para1:
          'Having a personal video from your pastor helps your members feel accepted, loved, and understood by your church. Mental health tends to be a subject that is avoided by most church members, but this video can break that stigma for your church.',
      },
      howToUseTruelifeCareInCounselingSessions: {
        para1: `TrueLifeCare.org is built for you to use these resources in your counseling sessions. Some pastors have used the videos before ever having a counseling session with an individual. Usually
        when a church member says they want to talk with the pastor, they have a certain topic. If you know what topic that is, you can direct them to watch a certain video on TLC and then have them reconnect with you. Sometimes the questions are already answered in the video and they won’t need to keep their appointment. Other times, having them watch a video allows for the “teaching” about a certain topic to be completed so you can go to the application of a strategy to help the individual. Another option is, after the first session, you can also use a TrueLifeCare.org video as homework for your next session. If there is a particular issue that you believe will help your church member, you can have them review the video and discuss it with you at the beginning of your next session. Furthermore, if you suspect a particular issue that a person is struggling with, but you are not sure, you can have them review a video to see if that sounds like something they struggle with currently. There are many ways to use the videos and other resources to help your church members have a more healthy and spiritually firm life.`,
      },
      evangelismProgram: {
        para1: 'Click To learn more about TrueLife.org Evangelism',
      },
    },
    churchAccess: {
      churchMembersAccessCredentials: {
        para1: 'Setup the login details you will share with your church members. We recommend making the email a general church email, or one for counseling specifically.',
      },
    },
    account: {
      churchMembershipInformation: {
        para1: 'Next Payment Date',
      },
    },
    support: {
      submitASupportRequest: {
        para1: 'Fill out the form on this page to request support from our customer service team.',
      },
    },
    updateBilling: {
      para1: 'Your Account Has An Open Invoice, Please Update Your Card Details',
    },
  },
  cardTitle: {
    accountPaymentDate: 'Account Payment Date',
    memberDashboardIntro: 'Member Dashboard Introduction',
    churchTraningVideo: 'Invitation Card Training Video',
    videoShareWithChuch: 'Jesus Story Training Video',
    getMostFromTruelife: 'Easily Use and Set Up You Church’s Jesus Stories',
    getWeeklyResults: 'Get Weekly Results',
    recentUpdate: 'Recent Update',
    howToEditChurchProfile: 'How to Edit Church Profile',
    editYourChurchProfile: 'Edit Your Church Profile',
    editChurchProfile: 'Edit Church Profile',
    howToOrderCards: 'How To Order Cards',
    cardOrderForm: 'Card Order Form',
    instructionsResources: 'Instructions & Resources',
    reOrderingInstructions: 'Re-Ordering Instructions',
    messageFromTruelifeVisitor: 'Messages From TrueLife.org Visitors To Your Church',
    trackYourProgress: 'Track Your Progress',
    submitTrackYourProgress: 'Submit a Track Your Progress',
    studyGuides: 'Study Guides',
    bulletinInserts: 'Bulletin Inserts',
    howToUseThisWizard: 'How To Use This Wizard',
    videoPlayerForYourChurchWebsite: 'Video Player For Your Church Website',
    categorySpecificPlayers: 'Category Specific Players',
    embedThisCodeInYourwebsite: 'Embed this code in your website',
    previewVideoPlayer: 'Preview Video Player',
    howToAddChurchLocation: 'How To Add Church Location',
    yourLocations: 'Your locations',
    locations: 'Locations',
    addYourChurchLocation: 'Add Your Church Location',
    howToSetupYourChurchProfile: 'How to setup your church profile',
    setupShareYourStory: 'Invite Your Church to the Jesus Story Challenge!',
    howToDirectChurchMembersToTruelifeCare: 'How to direct church members to TruelifeCare',
    whyYouShouldIncludeAPersonalVideoFromThePastor: 'Why you should include a personal video from the pastor',
    howToUseTruelifeCareInCounselingSessions: 'How to use Truelife Care in counseling sessions',
    evangelismProgram: 'Evangelism Program',
    updateChurchProfile: 'Update Church Profile',
    churchMembersAccessCredentials: 'Church Members Access Credentials',
    churchMembershipInformation: 'Church Membership Information',
    invoices: 'Invoices',
    transactions: 'Transactions',
    updateBillingInfo: 'Payment Information',
    supportRequest: 'Support Request',
    submitASupportRequest: 'Submit a Support Request',
    specificCategoryEmbed: 'Specific Category Embed',
    churchLocation: {
      adminUpdate: 'Update Church Location',
      adminAdd: 'Add Church Location',
      update: 'Update Your Church Location',
      add: 'Add Your Church Location',
    },
    socialMedia: 'Social Media',
    mediaResources: 'Media Resources',
    updateYourProfile: 'Update your profile',
    settings: 'Settings',
    connectToChurch: 'Connect to Church!',
  },
  button: {
    clear: 'Clear',
    download: 'Download',
    video: 'Video',
    downloadTrainngVideo: 'Download Video',
    updateAccount: 'Update account',
    copyToClipboard: 'Copy to clipboard',
    back: 'Back',
    nextSelectCategories: 'Next: Select Categories',
    nextGenerateEmbedCode: 'Next: Generate Embed Code',
    createLocation: 'Create Location',
    learnMore: 'Learn More',
    updateSettings: 'Update Settings',
    updateProfile: 'Update Profile',
    updateUser: 'Update User',
    createUser: 'Create User',
    updateAnswer: 'Update Answer',
    createAnswer: 'Create Answer',
    updateCategory: 'Update Category',
    createCategory: 'Create Category',
    updateSpeakerBio: 'Update Speaker Bio',
    createSpeakerBio: 'Create Speaker Bio',
    updateLocation: 'Update Location',
    createSpecificCategoryEmbed: 'Create Specific Category Embed',
    save: 'Save',
    submit: 'Submit',
    giveNow: 'Give now',
    upload: 'Upload',
    cancel: 'Cancel',
    continue: 'Continue',
    socialMediaKit: 'Social Media Kit',
    mediaPackage: 'Media Package',
    resetMyPassword: 'Reset my password',
    goBack: ' Go Back',
    login: 'Log In',
    signUp: 'Sign Up',
    yes: 'Yes',
    no: 'No',
    edit: 'Edit',
    delete: 'Delete',
    search: 'Search',
    reset: 'Reset',
    hidePreview: 'Hide Preview',
    preview: 'Preview',
    accountDetails: 'Account Details',
    takeThumbnail: 'Select the video thumbnail from the video',
  },
  label: {
    churchDescription: 'Church Description',
    videoEmbed: 'Video Embed',
    serviceTimes: 'Service Times',
    contactDetails: 'Contact Details',
    facebook: 'Facebook',
    twitter: 'Twitter',
    profileBannerPicture: 'Profile Banner Picture',
    pastorsHeadshot: 'Pastors Headshot',
    viewMessage: 'View Message',
    subject: 'Subject',
    from: 'From',
    yourDonationPageAddress: 'Your Donation Page Address',
    createSpecificCategoryEmbed: 'Create Specific Category Embed',
    embedThisCodeInYourWebsite: 'Embed this code in your website',
    name: 'Name',
    address: 'Address',
    address2: 'Address 2',
    city: 'City',
    state: 'State',
    zipCode: 'Zip code',
    country: 'Country',
    counselingPastor: 'Counseling Pastor',
    counselingContactEmail: 'Counseling Contact Email',
    churchAddress: 'Church Address',
    churchPhone: 'Church Phone',
    churchWebsite: 'Church Website',
    welcomeVideoEmbedCode: 'Welcome Video Embed Code',
    email: 'Email',
    password: 'Password',
    newPassword: 'New password',
    churchLoginDetail: 'Church Login Detail',
    careLogin: 'Care login',
    carePassword: 'Care password',
    invoiceID: 'Invoice ID',
    total: 'Total',
    download: 'Download',
    downloadPDF: 'Download PDF',
    status: 'Status',
    action: 'Action',
    amount: 'Amount',
    date: 'Date',
    invoice: 'Invoice',
    description: 'Description',
    firstNameFirstHalfChurchName: 'First Name (Or First Half Church Name)',
    lastNameSecondHalfChurchName: 'Last Name (Or Second Half Church Name)',
    cardNumber: 'Card Number',
    expirationDate: 'Expiration Date',
    CVV: 'CVV',
    pastorFirstName: 'Pastor First Name',
    pastorLastName: 'Pastor Last Name',
    role: 'Role',
    cellPhone: 'Cell Phone',
    churchName: 'Church Name',
    planInformation: 'Plan Information',
    plan: 'Plan',
    price: 'Price',
    errorAccountPlanInvalid: 'Account and Plan invalid',
    errorAccountInvalid: 'Account invalid',
    errorPlanInvalid: 'Plan invalid',
    selectFomGallery: 'Select cover image from gallery',
    uploading: 'Uploading',
    nextBillingDate: 'Next billing date',
    contactSupport: 'Contact Support',
    termsOfUse: 'Terms of Use',
    support: 'Support',
    contacts: 'Contacts',
    areYouSure: 'Are you sure?',
    firstName: 'First Name',
    lastName: 'Last Name',
    search: 'Search',
    directConnectionLink: 'Pastor Invitation Link:',
    supportEmail: 'Support Email',
    designerEmail: 'Designer Email',
    welcomeInstructionLink: 'Welcome Instruction Link(P)',
    shareStoryInstructionLink: 'Jesus Story Instruction Link(i)',
    mainDashboardVideoLink_p: 'Main Dashboard Video(P)',
    mainDashboardVideoLink_i: 'Mani Dashboard Video(i)',
    evangelismBootCampLink_p: 'Evangelism Boot Camp Video(P)',
    evangelismBootCampLink_i: 'Evangelism Boot Camp Video(i)',
    moderatorVideoLink: 'Moderator Video',
    individualSignupLink: 'Individual Signup',
    reminderStoryLink: 'Pop up reminder for story',
    reminderWelcomeLink: 'Pop up reminder for welcome',
  },
  placeholder: {
    pleaseInputTheLocationName: 'Please input the location name!',
    pleaseInputYourAddress: 'Please input your address!',
    pleaseInputYourCity: 'Please input your city!',
    pleaseInputYourState: 'Please input your state!',
    pleaseInputYourZipcode: 'Please input your zipcode!',
    pleaseInputYourCountry: 'Please input your country!',
    yourChurchWebsiteAddress: 'Your Church Website Address',
    yourDonationPageAddress: 'Your Donation Page Address',
    pleaseInputPastorFirstName: 'Please input Pastor First Name!',
    pleaseInputPastorLastName: 'Please input Pastor Last Name!',
    pleaseInputRole: 'Please input your role!',
    pleaseInputCellPhone: 'Please input your cell phone!',
    pleaseInputChurchName: 'Please input your church name!',
    pleaseInputEmail: 'Please input your email!',
    pleaseInputPassword: 'Please input your password!',
    pleaseInputCarePastor: 'Please input Care Pastor!',
    pleaseInputCareEmail: 'Please input Care Email!',
    pleaseInputCareAddress: 'Please input Care Address!',
    pleaseInputCarePhone: 'Please input Care Phone!',
    pleaseInputCareWebsite: 'Please input Care Website!',
    pleaseInputFirstName: 'Please input First Name!',
    pleaseInputLastName: 'Please input Last Name!',
    pleaseInputCardNumber: 'Please input Card Number!',
    pleaseInputMonth: 'Please input Month!',
    pleaseInputYear: 'Please input Year!',
    pleaseInputCVV: 'Please input CVV!',
    pleaseInputAddress: 'Please input address!',
    pleaseInputState: 'Please input state!',
    pleaseInputCity: 'Please input city!',
    pleaseInputCountry: 'Please input country!',
    pleaseInputChurchDescription: 'Please input Church Description!',
    pleaseInputContactDetails: 'Please input Contact Details!',
    pleaseInputTitle: 'Please input title!',
    pleaseInputSlug: 'Please input slug!',
    pleaseInputDescription: 'Please input description!',
    pleaseSelectAnswerType: 'Please select Answer Type!',
  },
};

export default {
  locale: 'es',
  localeAntd,
  messages,
};
